module.exports = __webpack_public_path__ + "img/map_gangnam_6f.0a25b0f9.jpg";